"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalVideoLayout = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const VerticalVideoLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const {
    modules,
    layout
  } = banner;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const firstModule = modules?.[0];
  if (!firstModule) {
    return (0, _utils.getModulesContentError)({
      debug,
      layout,
      modulePosition
    });
  }
  const {
    backgroundStorybookColor,
    content,
    link
  } = firstModule;
  const {
    title,
    caption,
    titleStorybookColor,
    horizontalAlignment = _editorialFetching.HorizontalContentAlignment.Left,
    textCollection
  } = content ?? {};
  const mappedBackgroundColor = (0, _presentationUtils.mapBackendColorToTheme)({
    backendColor: backgroundStorybookColor,
    fallBackColor: _mui.theme.palette.primary.main,
    theme: _mui.theme
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.VerticalVideo),
    backgroundColor: mappedBackgroundColor,
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.VideoArea, {
        alignment: horizontalAlignment,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.VideoLayout, {
          isStandaloneVideo: false,
          banner: banner,
          modulePosition: modulePosition,
          debug: debug
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContentArea, {
        "data-testid": getTestId(_constants.CONTENT_AREA),
        children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
          title: title,
          titleVariant: "h4",
          maxLines: 2,
          color: titleStorybookColor
        }) : null, caption ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Caption, {
          "data-testid": getTestId(_constants.CAPTION),
          variant: "body1",
          children: caption
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Description, {
          "data-testid": getTestId(_constants.DESCRIPTION),
          children: textCollection?.map((text, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml
          // eslint-disable-next-line react/no-array-index-key -- no suitable key
          , {
            html: (0, _utils.transformHtmlContent)(text),
            maxLines: 15
          }, index))
        }), link ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Button, {
          "data-testid": getTestId(_constants.BUTTON),
          link: link
        }) : null]
      })]
    })
  });
};
exports.VerticalVideoLayout = VerticalVideoLayout;
